import React from "react";
import { Form, Button } from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import AndtDEmailBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/EmailBoxWrapper";
import { phoneNumberValidator, emailValidator } from "../validators";
import { Actions, dire_detai_columnsDefs } from "../../../../constants";

class DirectorDetails extends React.Component {
  gridApi = null;

  state = {
    columnDefs: [
      {
        headerName: "Actions",
        width: 90,
        cellRendererFramework: (params) => {
          return (
            <>
              <EditOutlined
                className="grid-icons"
                onClick={() =>
                  this.props.handleDirectorDetails(
                    params.data.id,
                    Actions.update
                  )
                }
              />
              <DeleteOutlined
                className="grid-icons"
                onClick={() =>
                  this.props.handleDirectorDetails(
                    params.data.id,
                    Actions.delete
                  )
                }
              />
            </>
          );
        },
      },
      ...dire_detai_columnsDefs,
    ],
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  };

  render() {
    const {
      formRef,
      isDisabled,
      isIndia,
      additional_details,
      handleDirectorDetails,
    } = this.props;

    const { columnDefs } = this.state;

    return (
      <div className="row form-box">
        <legend className="form-legend">Directors/CEO/MD Details</legend>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="director_name"
            id="director_name"
            required={false}
            disabled={isDisabled}
            label="Name"
            message="Enter Director Name"
            placeholder="Enter Name"
            validators=""
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDEmailBoxWrapper
            decorator="director_email"
            id="director_email"
            required={false}
            disabled={isDisabled}
            label="Email"
            message="Enter Director Email"
            placeholder="Enter Director Email"
            validators={[{ validator: emailValidator }]}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="director_contactno"
            id="director_contactno"
            required={false}
            disabled={isDisabled}
            label="Contact No"
            message="Enter Director Contact No"
            placeholder="Enter Director Contact No"
            validators={isIndia ? [{ validator: phoneNumberValidator }] : ""}
            maxlength={30}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <Form.Item label=" ">
            <Button
              className="float-right"
              type="primary"
              htmlType="button"
              onClick={() => handleDirectorDetails(null, "insert")}
            >
              Add
            </Button>
          </Form.Item>
        </div>

        <div className="p-4 col-lg-12 col-md-12">
          <div
            className="table-responsive table-bordered
                table table-hover table-bordered
                ag-theme-balham gridViewDisplay 
                director-grid-height"
          >
            <AgGridReact
              columnDefs={columnDefs}
              onGridReady={this.onGridReady}
              rowData={additional_details.director_details}
              handleDirectorDetails={handleDirectorDetails}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DirectorDetails;
